import React, { useEffect, useRef } from 'react';
import { Modal } from 'react-bootstrap';
import { BehaviorSubject } from 'rxjs';
import { ModalSetting } from './modal.type';

export const modalSubject = new BehaviorSubject<ModalSetting[]>([]);

export function ModalInner({ modal }: { modal: ModalSetting }) {
  const modalInnerRef = useRef(null);
  const clientRef = useRef({
    distanceTop: 0,
    distanceLeft: 0,
    width: 0,
    height: 0,
  });
  const handleMousedownRef = useRef(null);

  useEffect(() => {
    // Draw modal header + content
    setTimeout(() => {
      const dialog = modalInnerRef.current?.dialog;

      if (!dialog) return;

      const modalHeader = dialog.querySelector('.modal-header');
      const modalContent = dialog.querySelector('.modal-content');

      if (!modalHeader || !modalContent) return;

      handleMousedownRef.current = (e) => {
        e.stopPropagation();

        const clientRec = modalContent.getBoundingClientRect();

        modalContent.style.width = clientRec.width + 'px';
        modalContent.style.height = clientRec.height + 'px';
        modalContent.style.position = 'fixed';

        clientRef.current.distanceTop = clientRec.top - e.clientY;
        clientRef.current.distanceLeft = clientRec.left - e.clientX;
        clientRef.current.width = clientRec.width;
        clientRef.current.height = clientRec.height;

        window.addEventListener('mouseup', handleMouseUp);
        window.addEventListener('mousemove', handlerMouseMoving);
      };

      const handleMouseUp = () => {
        window.removeEventListener('mousemove', handlerMouseMoving);
        window.removeEventListener('mouseup', handleMouseUp);
      };

      const handlerMouseMoving = (e) => {
        const client = clientRef.current;

        let top = e.clientY + client.distanceTop;
        let left = e.clientX + client.distanceLeft;

        if (top < 0) top = 0;

        if (left < 0) left = 0;

        if (top + client.height >= window.innerHeight) top = window.innerHeight - client.height;

        if (left + client.width >= window.innerWidth) left = window.innerWidth - client.width;

        modalContent.style.top = top + 'px';
        modalContent.style.left = left + 'px';
      };

      modalHeader.addEventListener('mousedown', handleMousedownRef.current);

      return () => modalHeader.removeEventListener('mousedown', handleMousedownRef.current);
    }, 100);
  }, []);

  return (
    <Modal
      ref={modalInnerRef}
      show={true}
      onHide={() => modal.modalRef.close(null)}
      className={`modal-dialog-centered  ${modal.options.className ? modal.options.className : ''}`}
      backdrop='static'
      keyboard={false}
      aria-labelledby='contained-modal-title-vcenter'
      centered
      size={modal.options.size || 'sm'}
    >
      <button
        type='button'
        className='close close-modal'
        data-dismiss='modal'
        aria-label='Close'
        onClick={() => modal.modalRef.close(null)}
      >
        <span aria-hidden='true'>&times;</span>
      </button>

      <modal.content modalRef={modal.modalRef} data={modal.options?.data} />
    </Modal>
  );
}
